<cap-content-header>
  <cap-title>
    {{ "GefundeneGebäude" | translate }}
  </cap-title>
  @if (gebaeudeListLoader) {
    <cap-title-functionbar>
      <cap-functionbar-searchresult-buttons [listLoader]="gebaeudeListLoader"></cap-functionbar-searchresult-buttons>
    </cap-title-functionbar>
  }
</cap-content-header>

<cap-list-loader [listLoader]="gebaeudeListLoader" [showZeilenSelect]="false">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-search">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th>
      <cap-column-header [columnName]="'EGID'" [sortModel]="tableSortModel.columns.get('egid')"></cap-column-header>
    </th>
    @if (avPlusErweiterung) {
      <th>
        <cap-column-header [columnName]="'KantGid'" [sortModel]="tableSortModel.columns.get('kantGid')"></cap-column-header>
      </th>
    }
    <th>
      <cap-column-header [columnName]="'VersicherungsNummerAbkürzung'" [sortModel]="tableSortModel.columns.get('versicherungsNummer')">
      </cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Gebaeude_Einzahl'" [sortModel]="tableSortModel.columns.get('kompaktGebaeudeArt')">
      </cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'GebäudeeingangsadresseAdressen'" [sortModel]="tableSortModel.columns.get('kompaktEingangsAdresse')">
      </cap-column-header>
    </th>
    <th>
      {{ "GrundstückGrundstücke" | translate }}
    </th>
    <th>
      <cap-column-header [columnName]="'Status'" [sortModel]="tableSortModel.columns.get('gebaeudeStatus')"></cap-column-header>
    </th>
    @if (avPlusErweiterung) {
      <th>
        <cap-column-header [columnName]="'EinzelobjektAbkürzung'" [sortModel]="tableSortModel.columns.get('istEinzelobjekt')">
        </cap-column-header>
      </th>
    }
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (gebaeude of gebaeudeListLoader?.items; track gebaeude) {
    <tr>
      <td>
        <cap-link [queryParams]="getQueryParams(gebaeude)" [target]="navTargets.NAV_GEBAEUDE">
          {{ gebaeude.model.egid }}
        </cap-link>
        <cap-gwr-link [egid]="gebaeude.model.egid"></cap-gwr-link>
      </td>
      @if (avPlusErweiterung) {
        <td>
          <cap-link [queryParams]="getQueryParams(gebaeude)" [target]="navTargets.NAV_GEBAEUDE">
            {{ gebaeude.model.kantGid }}
          </cap-link>
        </td>
      }
      <td>
        <cap-link [queryParams]="getQueryParams(gebaeude)" [target]="navTargets.NAV_GEBAEUDE">
          {{ gebaeude.model.versicherungsNummer }}
        </cap-link>
      </td>
      <td>
        <cap-link [queryParams]="getQueryParams(gebaeude)" [target]="navTargets.NAV_GEBAEUDE">
          {{ gebaeude.kompaktGebaeudeArt }}
        </cap-link>
      </td>
      <td>
        @for (entry of gebaeude.sortedEingangsAdressen; track entry) {
          <div>
            {{ entry | kompaktGebaeudeeingangsadresse }}
          </div>
        }
      </td>
      <td>
        <cap-gebaeude-list-grundstueck [grundstueckList]="gebaeude.grundstuecke$ | async"></cap-gebaeude-list-grundstueck>
      </td>
      <td>
        <cap-link [queryParams]="getQueryParams(gebaeude)" [target]="navTargets.NAV_GEBAEUDE">
          {{ gebaeude.model.gebaeudeStatus | translate }}
        </cap-link>
      </td>
      @if (avPlusErweiterung) {
        <td>
          <cap-link [queryParams]="getQueryParams(gebaeude)" [target]="navTargets.NAV_GEBAEUDE">
            {{ gebaeude.model.istEinzelobjekt ? ("Ja" | translate) : ("Nein" | translate) }}
          </cap-link>
        </td>
      }
    </tr>
  }
</ng-template>
